<template>
  <div id="lista-de-solicitacoes">
    <div
      class="container_pequeno container_com-fundo container_com-margem u-padding-media"
    >
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <div class="grade__linha grade__linha_alinhar-vertical-ao-topo">
        <div class="grade__coluna grade__coluna_3">
          <div class="titulo titulo_grande u-margem-inferior-pequena">
            Filtros
          </div>
        </div>
      </div>
      <div class="grade__linha u-margem-inferior-media">
        <div class="grade__coluna grade__coluna_6">
          <label class="formulario__label" for="nome">Nome</label>
          <input
            name="nome"
            type="text"
            id="nome"
            class="formulario__input"
            placeholder="Nome"
            v-model="nome"
          />
        </div>
        <div class="grade__coluna grade__coluna_3">
          <label class="formulario__label" for="cpf">CPF</label>
          <input
            name="cpf"
            type="text"
            id="cpf"
            class="formulario__input"
            placeholder="CPF"
            v-mask="'999.999.999-99'"
            v-model="cpf"
          />
        </div>
        <div class="grade__coluna grade__coluna_3">
          <label class="formulario__label" for="dataDeAssinatura"
            >Data de aprovação
            <span class="tooltips">
              <i class="far fa-info-circle" aria-hidden="true"></i>
              <span class="conteudo tooltip-top"
                >Data em que a solicitação foi aprovada pela AGEHAB
              </span>
            </span>
          </label>
          <input
            id="data-de-avaliacao"
            class="formulario__input"
            type="date"
            v-model="dataDeAprovacao"
          />
        </div>
      </div>
      <div class="grade__linha_alinhar-horizontal-direita formulario-button">
        <button
          type="button"
          class="botao botao_cor-terciaria botao_contorno botao_medio u-margem-direita-media"
          :disabled="deveDesabilitarBotaoDeLimpar"
          @click="limparFormulario()"
        >
          Limpar
        </button>
        <button
          type="button"
          class="botao botao_cor-terciaria botao_medio u-margem-direita-pequena"
          :disabled="deveDesabilitarBotaoDePesquisa"
          @click="obterSolicitacoes(this.paginaAtual)"
        >
          Pesquisar
        </button>
      </div>
      <hr
        class="u-margem-superior-grande u-margem-inferior-grande"
        v-if="existemSolicitacoesParaValidacaoDaMinuta"
      />
      <div
        class="grade__linha u-margem-inferior-media"
        v-if="existemSolicitacoesParaValidacaoDaMinuta"
      >
        <div class="grade__coluna grade__coluna_6">
          <div class="titulo titulo_grande u-margem-inferior-pequena">
            Lista de minutas a validar
          </div>
        </div>
      </div>
      <div
        class="grade__linha u-margem-superior-pequena"
        v-if="
          foiRealizadaAlgumaPesquisa &&
          !existemSolicitacoesParaValidacaoDaMinuta
        "
      >
        <div class="grade__coluna grade__coluna_12">
          <div class="estado-vazio">
            <i class="far fa-align-slash estado-vazio__icone"></i>
            <h2 class="estado-vazio__titulo">Nenhum resultado encontrado</h2>
            <p class="estado-vazio__texto">
              Você pode buscar solicitações pelo <strong>nome</strong>,
              <strong>CPF</strong> ou pela <strong>data de aprovação</strong>.
            </p>
          </div>
        </div>
      </div>
      <div class="grade__linha" v-if="existemSolicitacoesParaValidacaoDaMinuta">
        <div class="grade__coluna grade__coluna_12">
          <table class="tabela tabela_listrada tabela_com-largura-total">
            <thead>
              <tr>
                <th>Nome</th>
                <th class="u-texto-alinhado-ao-centro">CPF</th>
                <th class="u-texto-alinhado-ao-centro">
                  Data de aprovação
                  <span class="tooltips">
                    <i class="far fa-info-circle" aria-hidden="true"></i>
                    <span class="conteudo tooltip-top"
                      >Data em que a solicitação foi aprovada pela AGEHAB
                    </span>
                  </span>
                </th>
                <th class="u-texto-alinhado-ao-centro no-print">Visualizar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="solicitacao of solicitacoes" :id="solicitacao.Id">
                <td>{{ solicitacao.Nome }}</td>
                <td class="u-texto-alinhado-ao-centro">
                  {{ solicitacao.Cpf }}
                </td>
                <td class="u-texto-alinhado-ao-centro">
                  {{ solicitacao.DataDeAprovacao }}
                </td>
                <td class="u-texto-alinhado-ao-centro no-print">
                  <div class="dropdown dropdown_direita">
                    <button
                      class="botao botao_cor-terciaria botao_contorno botao_pequeno"
                      aria-haspopup="true"
                      @click="visualizarCertificado(solicitacao.Id)"
                    >
                      Visualizar
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="grade__linha" v-if="existemSolicitacoesParaValidacaoDaMinuta">
        <div class="grade__coluna grade__coluna_12">
          <paginacao
            @paginar="obterSolicitacoes"
            :paginaAtual="paginaAtual"
            :totalDePaginas="totalDePaginas"
            :totalDeRegistros="totalDeRegistros"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Loading from "../../shared/Loading";
import Paginacao from "../../shared/Paginacao";

export default {
  checkIn: null,
  checkOut: null,
  name: "lista-de-validacao-de-minuta",
  directives: { mask: AwesomeMask },
  components: { Loading, Paginacao },
  data() {
    return {
      paginaAtual: 1,
      totalDePaginas: null,
      totalDeRegistros: null,
      solicitacoes: [],
      loading: {
        visivel: true,
      },
      nome: "",
      cpf: "",
      dataDeAprovacao: "",
      deveDesabilitarPesquisa: false,
      foiRealizadaAlgumaPesquisa: false,
    };
  },
  watch: {
    nome(novaValor, valorAntigo) {
      let deveDesabilitar = novaValor == valorAntigo;
      this.deveDesabilitarPesquisa = deveDesabilitar;
    },
    cpf(novaValor, valorAntigo) {
      let deveDesabilitar = novaValor == valorAntigo;
      this.deveDesabilitarPesquisa = deveDesabilitar;
    },
    dataDeAprovacao(novaValor, valorAntigo) {
      let deveDesabilitar = novaValor == valorAntigo;
      this.deveDesabilitarPesquisa = deveDesabilitar;
    },
  },
  computed: {
    deveDesabilitarBotaoDePesquisa() {
      return this.deveDesabilitarPesquisa;
    },
    deveDesabilitarBotaoDeLimpar() {
      return !this.nome && !this.cpf && !this.dataDeAprovacao;
    },
    existemSolicitacoesParaValidacaoDaMinuta() {
      return this.solicitacoes && this.solicitacoes.length > 0;
    },
  },
  created() {
    this.exibirCarregamento();
    this.obterPaginaAtualDoLocalStorage();
    this.obterSolicitacoes(localStorage.paginaDaListaDeMinutas);
  },
  beforeDestroy() {
    if (window.location.href.indexOf("validacao-de-minuta") == -1) {
      localStorage.paginaDaListaDeMinutas = 1;
    }
  },
  methods: {
    obterSolicitacoes(pagina) {
      this.exibirCarregamento();
      this.atualizarPaginaNoLocalStorage(pagina);

      let filtro = {
        nome: this.nome,
        cpf: this.cpf,
        dataDeAprovacao: this.dataDeAprovacao || null,
        pagina: pagina,
      };
      this.$api
        .post("/ValidacaoDeMinuta/Filtrar", filtro)
        .then((response) => {
          const solicitacoes = response.data.Modelo;
          this.solicitacoes = solicitacoes;
          this.paginaAtual = response.data.PaginaAtual;
          this.totalDePaginas = response.data.TotalDePaginas;
          this.totalDeRegistros = response.data.TotalDeRegistros;
          this.deveDesabilitarPesquisa = true;

          this.esconderCarregamento();
        })
        .catch((error) => {
          this.esconderCarregamento();
        })
        .finally(() => {
          this.foiRealizadaAlgumaPesquisa = true;
        });
    },
    limparFormulario() {
      this.nome = "";
      this.cpf = "";
      this.dataDeAprovacao = "";
    },
    exibirCarregamento() {
      this.loading.visivel = true;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      window.scrollTo(0, 0);
    },
    exibirComoMoeda(valor) {
      return this.$moeda.formatar(valor);
    },

    visualizarCertificado(solicitacaoId) {
      this.$router.push({
        name: "ValidacaoDeMinuta",
        query: { idDaSolicitacao: solicitacaoId },
      });
    },
    obterPaginaAtualDoLocalStorage() {
      this.paginaAtual = !!localStorage.paginaDaListaDeMinutas
        ? parseInt(localStorage.paginaDaListaDeMinutas)
        : 1;
    },
    atualizarPaginaNoLocalStorage(pagina) {
      localStorage.paginaDaListaDeMinutas = pagina;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ListaDeValidacaoDeMinutas.vue?96e40a46